import { AppBundle } from 'api/optimalprint-sdk.d';
import { BundledProduct } from 'store/product/types';

type BundleGroup = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IBundleGroup;

const findPreviewForSelectedBundleProduct = (bundleGroup: BundleGroup[], selectedProduct: BundledProduct) => {
  const targetGroup = bundleGroup.find((group) => group.bundleGroupId === selectedProduct.bundleGroupId);
  if (!targetGroup) {
    return undefined;
  }
  const targetItem = targetGroup.items?.find((item) => item.productId === selectedProduct.productId);
  if (!targetItem) {
    return undefined;
  }
  return targetItem.previews?.[1] || targetItem.previews?.[0];
};

export default findPreviewForSelectedBundleProduct;
